import { render, staticRenderFns } from "./post-add.vue?vue&type=template&id=635d9042&scoped=true&"
import script from "./post-add.vue?vue&type=script&lang=js&"
export * from "./post-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=635d9042&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d9042",
  null
  
)

component.options.__file = "post-add.vue"
export default component.exports